import { lazy } from 'react';

const Home = lazy(() => import('./pages/home'));
const CustomerReport = lazy(
	() => import('./pages/mySalesPerformance/CustomerReport'),
);
const MPNReport = lazy(() => import('./pages/mySalesPerformance/MPNReport'));
const CustomerContactEngagement = lazy(
	() => import('./pages/myEmailEngagement/CusContEngagementV2'),
);
const MPNCostBook = lazy(() => import('./pages/mySources/MPNCostBook'));
const MPNQueue = lazy(() => import('./pages/mySources/MPNQueue'));
const NetComponents = lazy(() => import('./pages/NetComponents'));
const FreightTable = lazy(() => import('./pages/FreightTable'));
const EPAccTags = lazy(() => import('./pages/admin/EPAccTags'));
const SourcingAssignments = lazy(
	() => import('./pages/admin/SourcingAssignments'),
);
const BobcatExclusionList = lazy(
	() => import('./pages/admin/BobcatExclusionList'),
);
const APITokenLimits = lazy(() => import('./pages/admin/APITokenLimits'));
const ChahGPTUsageReport = lazy(
	() => import('./pages/admin/ChatGPTUsageReport'),
);
const SupplierPrices = lazy(() => import('./pages/mySources/supplierPrices'));
const HouseAccounts = lazy(() => import('./pages/houseAccounts'));
const HouseAccountsAdmin = lazy(() => import('./pages/admin/HouseAccount'));
const ChatGptKeywords = lazy(() => import('./pages/admin/ChatGptKeywords'));
const AssignToHouse = lazy(() => import('./pages/assignToHouse'));
const ManagementReport = lazy(() => import('./pages/managementReport1'));
const AccountAllocationLog = lazy(
	() => import('./pages/admin/AccountAllocationLog'),
);
const BounceBackTracker = lazy(() => import('./pages/BounceBackTrackerV2'));
const SRAccountsSummary = lazy(() => import('./pages/admin/SRAccountsSummary'));
const HouseAccountExclusions = lazy(
	() => import('./pages/admin/HouseAccountExclusions'),
);
const CustomerContacts = lazy(() => import('./pages/customerContacts'));
const CustomerOutreach = lazy(() => import('./pages/CustomerOutreach'));
const LinkedInCleanser = lazy(() => import('./pages/admin/LinkedInCleanser'));
const GlobalChatGptReport = lazy(
	() => import('./pages/admin/GlobalChatgptReport'),
);
const CustomerPrices = lazy(() => import('./pages/CustomerPrices'));
const MassMail = lazy(() => import('./pages/MassMail'));
const APIHealthChecker = lazy(() => import('./pages/admin/APIHealthChecker'));
const ChipfinderOctapartSources = lazy(
	() => import('./pages/admin/ChipfinderOctapartSources'),
);
const PreferredsuppliersbyBrand = lazy(
	() => import('./pages/PreferredsuppliersbyBrand'),
);
const SalesRepReportTracker = lazy(
	() => import('./pages/admin/SalesRepReportTracker'),
);
const HelpDeskTracker = lazy(() => import('./pages/HelpDeskTracker'));
const LearnCentre = lazy(() => import('./pages/LearnCentre'));
const FranchisedBrands = lazy(() => import('./pages/admin/FranchisedBrands'));
const LeadsExclusion = lazy(() => import('./pages/admin/LeadTimeExclusion'));
const MyPastEmails = lazy(() => import('./pages/MyPastEmails'));
const MailBoxStroageDetails = lazy(
	() => import('./pages/admin/MailBoxStorageDetails'),
);
const WebsiteLeads = lazy(() => import('./pages/admin/WebsiteLeads'));
const CustomerOutreachThreshold = lazy(
	() => import('./pages/admin/CustomerOutreachThreshold'),
);
const SupplierContacts = lazy(() => import('./pages/SupplierContacts'));
const SectionAccess = lazy(() => import('./pages/admin/SectionAccess'));
const NotAuthorized = lazy(() => import('./components/notAuthorized'));
const EagleBobcatMatch = lazy(() => import('./pages/EagleBobcatMatch'));
const SOBackorders = lazy(() => import('./pages/SOBackorders'));
const RFQQueue = lazy(() => import('./pages/RFQQueue'));
const FranchiseQueue = lazy(() => import('./pages/FranchiseQueue'));
const ExternalEmails = lazy(() => import('./pages/ExternalEmails'));
const BackorderManagement = lazy(() => import('./pages/BackorderManagement'));
const ChipsFinderLogs = lazy(() => import('./pages/ChipsFinderLogs'));
const InventoryEngine = lazy(() => import('./pages/admin/InventoryEngine'));
const SCIInventory = lazy(() => import('./pages/SCIInventory'));
const PriceBook = lazy(() => import('./pages/PriceBook'));
const EaglePriceBookEmailLogs = lazy(
	() => import('./pages/admin/EaglePriceBookEmailLogs'),
);
// const OrderManagement = lazy(() => import('./pages/OrderManagement'));

// Router config (UNCHANGED)
const router = [
	{ path: '/', element: <Home /> },
	{ path: '/house-accounts', element: <HouseAccounts /> },
	{ path: '/assign-to-house', element: <AssignToHouse /> },
	{ path: '/customer-contacts', element: <CustomerContacts /> },
	{ path: '/supplier-contacts', element: <SupplierContacts /> },
	{ path: '/management-report', element: <ManagementReport /> },
	{ path: '/customer-outreach', element: <CustomerOutreach /> },
	{ path: '/past-emails', element: <MyPastEmails /> },
	{ path: '/mass-mail', element: <MassMail /> },
	{ path: '/customer-report', element: <CustomerReport /> },
	{ path: '/mpn-report', element: <MPNReport /> },
	{ path: '/email-engagement', element: <CustomerContactEngagement /> },
	{ path: '/external-emails', element: <ExternalEmails /> },
	{ path: '/franchise-queue', element: <FranchiseQueue /> },
	{ path: '/mpn-queue', element: <MPNQueue /> },
	{ path: '/customer-rfqs', element: <CustomerPrices /> },
	{ path: '/eagle-bobcat-match', element: <EagleBobcatMatch /> },
	{ path: '/supplier-prices', element: <SupplierPrices /> },
	{ path: '/my-sources/supplier-prices?mpn=', element: <SupplierPrices /> },
	{ path: '/netcomponents', element: <NetComponents /> },
	{ path: '/freight-by-supplier', element: <FreightTable /> },
	{
		path: '/preferred-suppliers-by-brand',
		element: <PreferredsuppliersbyBrand />,
	},
	{ path: '/bounceback-tracker', element: <BounceBackTracker /> },
	{ path: '/mpn-cost-book', element: <MPNCostBook /> },
	{ path: '/help-desk', element: <HelpDeskTracker /> },
	{ path: '/learn-centre', element: <LearnCentre /> },
	{ path: '/franchised-line-pricebook', element: <PriceBook /> },
	{ path: '/rfq-queue', element: <RFQQueue /> },
	{ path: '/so-backorders', element: <SOBackorders /> },
	{ path: '/backorder-management', element: <BackorderManagement /> },
	{ path: '/chipsfinder-logs', element: <ChipsFinderLogs /> },
	{ path: '/sci-inventory', element: <SCIInventory /> },
	// { path: '/order-management', element: <OrderManagement /> },
	{ path: '/admin/chatgpt-keywords', element: <ChatGptKeywords /> },
	{ path: '/admin/eagle-processor-account-tags', element: <EPAccTags /> },
	{ path: '/admin/sourcing-assignments', element: <SourcingAssignments /> },
	{
		path: '/admin/bobcat-eagle-exclusions-list',
		element: <BobcatExclusionList />,
	},
	{ path: '/admin/linkedin-cleanser', element: <LinkedInCleanser /> },
	{ path: '/admin/global-chatgpt-report', element: <GlobalChatGptReport /> },
	{ path: '/admin/chatgpt-usage-report', element: <ChahGPTUsageReport /> },
	{ path: '/admin/api-token-limits', element: <APITokenLimits /> },
	{ path: '/admin/house-account', element: <HouseAccountsAdmin /> },
	{ path: '/admin/account-allocation-log', element: <AccountAllocationLog /> },
	{ path: '/admin/sr-accounts-summary', element: <SRAccountsSummary /> },
	{ path: '/admin/franchised-brands', element: <FranchisedBrands /> },
	{
		path: '/admin/house-account-exclusion',
		element: <HouseAccountExclusions />,
	},
	{
		path: '/admin/mailbox-stroage-details',
		element: <MailBoxStroageDetails />,
	},
	{ path: '/admin/api-health-checker', element: <APIHealthChecker /> },
	{ path: '/admin/chipfinder-sources', element: <ChipfinderOctapartSources /> },
	{ path: '/admin/sales-report-tracker', element: <SalesRepReportTracker /> },
	{ path: '/admin/leads-exclusion', element: <LeadsExclusion /> },
	{ path: '/admin/website-leads', element: <WebsiteLeads /> },
	{
		path: '/admin/customer-outreach-threshold',
		element: <CustomerOutreachThreshold />,
	},
	{ path: '/admin/section-access', element: <SectionAccess /> },
	{ path: '/admin/inventory-engine', element: <InventoryEngine /> },
	{ path: '/not-authorized', element: <NotAuthorized /> },
	{
		path: '/admin/eagle-price-book-email-logs',
		element: <EaglePriceBookEmailLogs />,
	},
];

export default router;
